<app-confirmation-modal-margin></app-confirmation-modal-margin>
<MarginApp-filter></MarginApp-filter>
<div class="container-fluid" style="height: 100%;">
<MarginCalculatorApp-view></MarginCalculatorApp-view>
</div>
